import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { OccupancyDailyResponseSchema } from "../response/OccupancyDailyResponse";

interface Filter {
    start: string; // YYYY-MM-DD
    end: string;   // YYYY-MM-DD
    property_id: string;
    room_type_id?: string;
    group_by?: 'date' | 'room_type'; // Optional grouping parameter
}

interface OccupancyParams {
    filter?: Filter;
    enabled?: boolean;
}

const API_VERSION = 'v4';

const useOccupancyDaily = (query: OccupancyParams) => {
    return useQuery({
        // Saran untuk menyertakan room_type_id di queryKey tetap berlaku
        queryKey: [
            'bookings', 'daily', 'calendar', 'occupancy', 'day',
            query.filter?.property_id,
            query.filter?.start,
            query.filter?.end,
            query.filter?.room_type_id,
            query.filter?.group_by
        ],
        queryFn: async () => {
            // [PERUBAHAN UTAMA]: Kirim objek dengan key 'filter' ke dalam params
            const response = await privateApi.get(`/${API_VERSION}/occupancy-daily`, {
                params: {
                    filter: query.filter
                }
            });

            const validationResult = OccupancyDailyResponseSchema.safeParse(response.data);
            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid Occupancy daily data format");
            }
            return validationResult.data;
        },
        enabled: query.enabled !== false && !!query.filter?.property_id,
        retry: import.meta.env.VITE_MAX_RETRY,
        refetchOnWindowFocus: false
    });
};

export default useOccupancyDaily;